import axios from 'axios';

const updateSettings = settings => {
  return axios.put('faqs/settings', settings);
};

export { updateSettings };
